import { FC, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserStore } from '@/store/useUserStore';
import { getSafeRedirectPath } from './redirect';
import { PATHS } from './paths';

interface AuthRedirectProps {
  children: ReactNode;
}

const AuthRedirect: FC<AuthRedirectProps> = ({ children }) => {
  const { token } = useUserStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    // 如果当前在 verify-email 或 google-callback 页面，不进行自动重定向
    // 让这些组件自己处理跳转逻辑（需要先检查 is_first_login 等状态）
    if (location.pathname === PATHS.verifyEmail || location.pathname === PATHS.googleCallback) return;

    const from = new URLSearchParams(location.search).get('from');
    const redirectTo = getSafeRedirectPath(from);
    if (redirectTo !== location.pathname) {
      navigate(redirectTo, { replace: true });
    }
  }, [token, location.pathname, location.search, navigate]);

  return <>{children}</>;
};

export default AuthRedirect;
